// read only mode is triggered if readonly EXISTS as query param, it doesn't matter its value
// if not it will use the read only from tablebee settings

export default function(to, from, next) {
  let queryReadOnly = window.store.getters["Config/queryReadOnly"];
  if (
    to.query.readonly ||
    Object.prototype.hasOwnProperty.call(to.query, "readonly")
  ) {
    if (!queryReadOnly) {
      window.store.commit("Config/setQueryReadOnly", true);
      return next({ name: "Menu", query: { readonly: true } });
    } else if (to.name !== "Menu") {
      return next({ name: "Menu", query: { readonly: true } });
    }
  } else {
    window.store.commit("Config/setQueryReadOnly", false);
  }

  return next();
}
